const prefix = '@@GENERAL';

export const ASSIGNMENT_INFO_LOADING = `${prefix}__ASSIGNMENT_INFO_LOADING`;
export const FAVORITES_LIST_LOADING = `${prefix}__FAVORITES_LIST_LOADING`;
export const LOOKUP_FILTERS_LOADING = `${prefix}__LOOKUP_FILTERS_LOADING`;
export const LOOKUP_TABLES_LOADING = `${prefix}__LOOKUP_TABLES_LOADING`;
export const SET_DATA = `${prefix}__SET_DATA`;
export const SET_ERROR = `${prefix}__SET_ERROR`;
export const RESET_DATA = `${prefix}__RESET_DATA`;
